export default __webpack_public_path__ + "static/media/logo_yellow.371f7323.png";